import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {LaboratoriosModel} from "./laboratorios.model";
import {LaboratoriosService} from './laboratorios.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-laboratorios-form',
  templateUrl: './laboratorios-form.component.html'
})
export class LaboratoriosFormComponent implements OnInit {

  enviandoForm = false;
  form: FormGroup;
  title: string;
  laboratorio: LaboratoriosModel = new LaboratoriosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private laboratoriosService: LaboratoriosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_laboratorio'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarLaboratorio');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarLaboratorio') : this.func.traduzir('front.cadastrarNovoLaboratorio');
      }

      if (!id) {
        return;
      }

      this.laboratoriosService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.title = this.func.traduzir('front.editarLaboratorio')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarLaboratorio') + ': ' + json.Payload[0].nome;
            }
            this.laboratorio = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    let result,
      values = this.form.value;

    this.enviandoForm = true;

    if (values.id) {
      result = this.laboratoriosService.editar(values, values.id);
    } else {
      result = this.laboratoriosService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'laboratorios']),
      error => {
        let json = error.json();
        this.func.showErro(json);

        this.enviandoForm = false;

        for(let i in json.Message.ErrorInput){
          let erro = {};
          erro[i] = json.Message.ErrorInput[i];
          this.form.controls[i].setErrors(erro);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/laboratorios/laboratorios-form.component.ts